// extracted by mini-css-extract-plugin
export default {"notification":"PrivacyPolicyNotification_notification__RdLSP","link":"PrivacyPolicyNotification_link__3K+c1"};